import { render, staticRenderFns } from "./shipDetail.vue?vue&type=template&id=34dc9912&scoped=true"
import script from "./shipDetail.vue?vue&type=script&lang=js"
export * from "./shipDetail.vue?vue&type=script&lang=js"
import style0 from "./shipDetail.vue?vue&type=style&index=0&id=34dc9912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc9912",
  null
  
)

export default component.exports